import { render, staticRenderFns } from "./MenstruumDetail.vue?vue&type=template&id=4e96ddaf"
import script from "./MenstruumDetail.vue?vue&type=script&lang=js"
export * from "./MenstruumDetail.vue?vue&type=script&lang=js"
import style0 from "./MenstruumDetail.vue?vue&type=style&index=0&id=4e96ddaf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports